import React from 'react';

export const DistillTheMessage = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="80" height="80" rx="40" fill="#BAE1D1" />
    <path
      d="M54 23C58.4183 23 62 26.5817 62 31L62 45.3333C62 49.7516 58.4183 53.3333 54 53.3333L41.4212 53.3333C41.2123 53.3333 41.0087 53.3987 40.8389 53.5204L30.5823 60.8667C29.9206 61.3406 29 60.8677 29 60.0537L29 54.3333C29 53.7811 28.5523 53.3333 28 53.3333L26 53.3333C21.5817 53.3333 18 49.7516 18 45.3333L18 31C18 26.5817 21.5817 23 26 23L54 23Z"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <line
      x1="44"
      y1="36"
      x2="52"
      y2="36"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="44"
      y1="41"
      x2="56"
      y2="41"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect
      x="38"
      y="31"
      width="14"
      height="14"
      rx="7"
      transform="rotate(90 38 31)"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);
